import { makeApiCall } from "@swiggy-private/js-utils";
import { API_ENDPOINTS, DINEOUT_PARTNER_API_HOST } from "../constants/api";
import { TableConfig } from "../hooks/useTableConfig";
import { customApiCall, IOptions } from "../utils/api";

export const recordQrScan = async (params: TableConfig, _makeApiCall: typeof makeApiCall) => {
    const { restaurantId, tableId } = params;

    const options: IOptions = {
        method: "POST",
        bodyParams: { restaurant_id: restaurantId, table_id: tableId },
    };

    const response = await customApiCall({
        _makeApiCall,
        apiHost: DINEOUT_PARTNER_API_HOST,
        apiEndpoint: API_ENDPOINTS.DIGITAL_MENU_QR_SCAN,
        opts: options,
    });

    return response;
};
